import { useCallback, useRef } from "react";
import { navigate } from "gatsby";
import { isExternalUrl } from "../components/link/utils";
import { useAutocomplete } from "./useAutocomplete";
import type { GetMicroCopy } from "../components/MicroCopy";

export const navigateWithSearchTerm = (
  selectedValue: string,
  searchTerm: string
) => {
  if (!selectedValue) {
    return;
  }

  let finalUrl = selectedValue;

  if (selectedValue.includes("/search/?tab=")) {
    if (searchTerm) {
      finalUrl += `&q=${encodeURIComponent(searchTerm)}`;
    }
  }

  if (isExternalUrl(finalUrl)) {
    return;
  }

  navigate(finalUrl);
};

export const usePredictiveSearch = (
  getMicroCopy: GetMicroCopy,
  countryCode: string,
  variantCodeToPathMap?: Record<string, string>
) => {
  const searchTermRef = useRef("");
  const { suggestions, fetchSuggestions } = useAutocomplete(
    getMicroCopy,
    countryCode,
    undefined,
    variantCodeToPathMap
  );

  const handleSearchTermChange = useCallback(
    (term: string) => {
      searchTermRef.current = term;
      fetchSuggestions(term);
    },
    [fetchSuggestions]
  );

  const handleSelection = useCallback((selectedValue: string) => {
    navigateWithSearchTerm(selectedValue, searchTermRef.current);
  }, []);

  return {
    suggestions,
    fetchSuggestions: handleSearchTermChange,
    handleSelection
  };
};
